module.exports = __webpack_public_path__ + "img/disenosintitulo2.256b745b.webp";